import { useContext } from "react";
import { LabContext } from "../../context/labContext";
import AnimateLoader from "../AnimateLoader";

import Navigator from "./Navigator";
import { useNavigate } from "react-router-dom";

const ListLabs = () => {
    const { labs } = useContext(LabContext);
    const navigate = useNavigate();

    if (labs === null) {
        return <AnimateLoader />;
    }

    if (labs === false) {
        return <div>No se encontraron detalles</div>;
    }


    return (
        <div className="row justify-content-between">
            <strong className="fs-1">code laboratory</strong>
            {labs.map(lab => (
                <div
                    onClick={() => {
                        navigate(`/lab/${lab.id}`);
                    }}

                    className="col-md-6 col-12"
                    key={lab.id}>
                    <div className="window shadow mt-3">
                        <Navigator />
                        <div className="p-5 fs-2 text-center">
                            {lab.title}
                        </div>
                        <div className={`tag  ${lab.type == 'video' ? "bg-green" : "bg-yellow"}`}>
                            <span> {lab.type} </span>
                        </div>
                    </div>
                </div>))}
        </div>
    )
}

export default ListLabs;